import {
  doc,
  getFirestore,
  updateDoc,
} from 'firebase/firestore';

export default function updateTuningHistoryNote(id, note) {
  return updateDoc(doc(getFirestore(), 'tuningHistory', id), { note });
}
